var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.5, 14)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    values: "1;0.85;1",
    dur: "1.5s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-14.5, -14)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.75,
    y: 3,
    width: 22,
    height: 22,
    rx: 11,
    fill: "#A9C2E9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.75,
    y: 3,
    width: 22,
    height: 22,
    rx: 11,
    stroke: "#809DCB",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1208 13.734L12.3855 10.018C12.3731 10.0082 12.3583 10.0022 12.3426 10.0005C12.3269 9.9988 12.3111 10.0016 12.297 10.0085C12.2828 10.0155 12.2709 10.0263 12.2626 10.0397C12.2543 10.0532 12.2499 10.0687 12.25 10.0845V10.9003C12.25 10.952 12.2742 11.0016 12.3141 11.0333L16.0956 14L12.3141 16.9666C12.2731 16.9983 12.25 17.0479 12.25 17.0996V17.9154C12.25 17.9861 12.3309 18.0252 12.3855 17.9819L17.1208 14.2659C17.161 14.2344 17.1936 14.194 17.216 14.1479C17.2384 14.1018 17.25 14.0512 17.25 14C17.25 13.9487 17.2384 13.8981 17.216 13.852C17.1936 13.8059 17.161 13.7655 17.1208 13.734Z",
    fill: "#003B97"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveArrowIcon);
export default __webpack_public_path__ + "static/media/active_arrow_icon.298613e489a2931ca27fb4983ba51664.svg";
export { ForwardRef as ReactComponent };